import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useLanguage } from "../../../../Translations/LenguageContext";
import Spinner from "../../../../Components/Spinner";
import ErrorMessage from "../../../../Components/ErrorMessage";
import { useNavigate, useParams } from "react-router-dom";

const sqlTypes = [
    "INT",
    "BIGINT",
    "SMALLINT",
    "TINYINT",
    "VARCHAR",
    "CHAR",
    "TEXT",
    "DATE",
    "DATETIME",
    "BOOLEAN",
    "FLOAT",
    "DOUBLE",
    "DECIMAL"
];

const NewTableModal = ({ show, handleClose, fetchRecords, schemas, instanceData }) => {
    const { t } = useLanguage();
    const navigate = useNavigate();
    const { project_id, db_id } = useParams();
    const user_id = sessionStorage.getItem("user_id");
    const [schema, setSchema] = useState(
        schemas?.[0] || instanceData?.sql_type === "sqlserver" ? "dbo" : "public"
    ); 

    useEffect(() => {
        if (schemas?.length) {
            setSchema(schemas[0]);
        }
    }, [schemas]);


    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({ message: "", display: false });

    const [tableName, setTableName] = useState("");
    const [tableDesc, setTableDesc] = useState("");

    const [dbUser, setDbUser] = useState("");
    const [dbPassword, setDbPassword] = useState("");

    const [columns, setColumns] = useState([{ label: "", type: "VARCHAR" }]);

    const HandleSave = async () => {
        if (!tableName.trim()) return setError({ message: "Table name required", display: true });
        if (!tableDesc.trim()) return setError({ message: "Table description required", display: true });
        if (!schema.trim()) return setError({ message: "Schema is required", display: true });

        for (let i = 0; i < columns.length; i++) {
            const col = columns[i];
            if (!col.label.trim()) return setError({ message: `Column ${i + 1} label is required`, display: true });
            if (!col.type) return setError({ message: `Column ${i + 1} type is required`, display: true });
        }

        setLoading(true);

        const data = {
            user_id,
            project_id,
            db_id,
            tableName,
            tableDesc,
            columns,
            schema
        };

        try {
            const response = await fetch("https://backend.erioon.com/create_table", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(data),
            });

            setLoading(false);

            if (response.ok) {
                const result = await response.json();
                const coll_id = result.table_id;
                setError({ message: "", display: false });
                fetchRecords();
                handleClose();
            } else {
                const errResponse = await response.json().catch(() => null);
                if (errResponse?.details?.includes("already exists")) {
                    setError({ message: `Table "${tableName}" already exists`, display: true });
                } else {
                    setError({ message: errResponse?.error || "Failed to create table", display: true });
                }
            }
        } catch (err) {
            setLoading(false);
            setError({ message: `Table creation failed: ${err.message}`, display: true });
        }
    };


    const CloseModal = () => {
        handleClose();
        setError({ message: "", display: false });
        setColumns([{ label: "", type: "VARCHAR" }]);
        setTableName("");
        setTableDesc("");
        setDbUser("");
        setDbPassword("");
    };

    const AddColumn = () => setColumns([...columns, { label: "", type: "VARCHAR", length: "" }]);
    const RemoveColumn = (index) => {
        if (columns.length > 1) {
            setColumns(columns.filter((_, i) => i !== index));
        }
    };
    const UpdateColumn = (index, field, value) => {
        const updated = [...columns];
        updated[index][field] = value;
        setColumns(updated);
    };

    return (
        <Modal show={show} onHide={CloseModal} className="modal_share">
            <div className="share_main_cont_modal">
                <p className="share_label"> New table</p>
                <p className="share_label_desc">Fill in the required details and define the columns for your new table.</p>
                <p className="columns_section_title">Table information</p>
                <input
                    className="api_name_input"
                    placeholder="Table name"
                    value={tableName}
                    onChange={(e) => setTableName(e.target.value)}
                />
                <textarea
                    className="api_name_description"
                    placeholder="Table description"
                    value={tableDesc}
                    onChange={(e) => setTableDesc(e.target.value)}
                />
                <select
                    className="api_name_select"
                    value={schema}
                    onChange={(e) => setSchema(e.target.value)}
                >
                    {(schemas || []).length > 0 ? (
                        schemas.map((sch) => (
                            <option key={sch} value={sch}>
                                {sch}
                            </option>
                        ))
                    ) : (
                        <option key={schema} value={schema}>
                            {schema}
                        </option>
                    )}
                </select>

                <div className="columns_section">
                    <p className="columns_section_title">Add columns <button className="add_column_btn" onClick={AddColumn}><i className="fa-solid fa-plus"></i> Add Column</button></p>
                    {columns.map((col, idx) => (
                        <div key={idx} className="column_row">
                            <input
                                placeholder="Label"
                                value={col.label}
                                onChange={(e) => UpdateColumn(idx, "label", e.target.value)}
                                className="api_name_input"
                            />
                            <select
                                value={col.type}
                                onChange={(e) => UpdateColumn(idx, "type", e.target.value)}
                                className="column_select"
                            >
                                {sqlTypes.map((type) => (
                                    <option key={type} value={type}>{type}</option>
                                ))}
                            </select>
                            {columns.length > 1 && (
                                <button
                                    className="remove_row_btn"
                                    onClick={() => RemoveColumn(idx)}
                                    disabled={columns.length === 1}
                                >
                                    <i className="fa-solid fa-x"></i>
                                </button>
                            )}
                        </div>
                    ))}
                </div>
            </div>

            <div className="modal_footer">
                <ErrorMessage err={error} />
                <div className="footer_btn_cont">
                    <button className="save_btn" onClick={HandleSave}>
                        {loading ? <Spinner loading={loading} /> : t.save}
                    </button>
                    <button className="cancel_btn" onClick={CloseModal}>{t.cancel}</button>
                </div>
            </div>
        </Modal>
    );
};


export default NewTableModal;
